import React from 'react';
import { FileText } from 'lucide-react';

export function KeyboardShortcuts() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <FileText className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Skróty klawiaturowe
        </h2>
      </div>
      
      <div className="space-y-4">
        <p className="body-medium">
          Strona obsługuje następujące skróty klawiaturowe:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Alt + + lub Alt + Równa się</span>
              <span className="body-medium no-margin">Powiększ tekst</span>
            </div>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Alt + -</span>
              <span className="body-medium no-margin">Zmniejsz tekst</span>
            </div>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Alt + C</span>
              <span className="body-medium no-margin">Przełącz tryb wysokiego kontrastu</span>
            </div>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Alt + D</span>
              <span className="body-medium no-margin">Przełącz między trybem jasnym i ciemnym</span>
            </div>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Tab</span>
              <span className="body-medium no-margin">Nawigacja między elementami</span>
            </div>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Enter lub Spacja</span>
              <span className="body-medium no-margin">Aktywacja elementu</span>
            </div>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Esc</span>
              <span className="body-medium no-margin">Zamknij okno dialogowe lub menu</span>
            </div>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-4 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <span className="label-large">Strzałki</span>
              <span className="body-medium no-margin">Nawigacja w menu i listach</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}